import {
  DescriptionOutlined,
  History,
  Inventory2Outlined,
  ViewKanbanOutlined,
} from '@mui/icons-material';
import cn from 'classnames';
import { observer } from 'mobx-react-lite';
import { NavLink } from 'react-router-dom';

import { Collapsed } from '@/components/Collapsed';
import { trackerUrls } from '@/tracker/config/urls';
import { useIssueDrawer } from '@/tracker/features/issueDrawer';
import { RecentItem, useTrackerStore } from '@/tracker/model';
import { ExpandIcon } from '@/tracker/ui/ExpandIcon';

import s from '../navItem.module.scss';

const ICONS: Record<RecentItem['type'], React.ReactNode> = {
  issue: <DescriptionOutlined />,
  queue: <Inventory2Outlined />,
  board: <ViewKanbanOutlined />,
};

/** Недавно открытые задачи, очереди и доски — как «Недавние» в панели Яндекс Трекера */
const RecentSection = observer(() => {
  const trackerStore = useTrackerStore();
  const { issueKey, issueLink } = useIssueDrawer();
  const { recent } = trackerStore;
  const isOpen = trackerStore.isNavSectionOpen('recent');

  return (
    <>
      <button
        type="button"
        className={cn(s.nav__link, s.nav__heading)}
        aria-expanded={isOpen}
        onClick={() => trackerStore.toggleNavSection('recent')}
      >
        <History />
        <span className={s.nav__label}>Недавние</span>
        <ExpandIcon isOpen={isOpen} />
      </button>

      <Collapsed opened={isOpen}>
        <div className={s.nav__favorites} role="group" aria-label="Недавние">
          {recent.map(({ type, id, name }) => {
            const isIssue = type === 'issue';
            const label = isIssue ? `${id} ${name}` : name;
            // Задача открывается карточкой поверх текущего экрана
            const to = {
              issue: issueLink(id),
              queue: trackerUrls.queue(id),
              board: trackerUrls.board(id),
            }[type];

            return (
              <NavLink
                key={`${type}:${id}`}
                to={to}
                // Путь задачи — текущая страница, поэтому активна она по открытой карточке
                className={({ isActive }) =>
                  cn(
                    s.nav__link,
                    s.nav__link_recent,
                    (isIssue ? issueKey === id : isActive) && s.nav__link_active,
                  )
                }
                title={label}
              >
                {ICONS[type]}
                <span className={s.nav__label}>{label}</span>
              </NavLink>
            );
          })}
          {!recent.length && (
            <span className={s.nav__hint}>Здесь появятся открытые задачи, очереди и доски</span>
          )}
        </div>
      </Collapsed>
    </>
  );
});

export { RecentSection };
